import { render } from "./FileUploader.vue?vue&type=template&id=22a979c8"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=22a979c8&lang=css"
script.render = render

export default script